var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ds-control dsf-sc-table-design dsf-sc-biaofulu",class:_vm.getCss,on:{"click":_vm.click}},[_c('img',{attrs:{"src":'./static/img/project/tableDesign/biaofulu.jpg'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }